import { LazyLoad } from 'app/utils';

export const ContactListPage = LazyLoad(
  () => import('./index'),
  (module) => module.ContactListPage,
);
